// @ts-nocheck
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import { userRoles } from "@store/constants";
import { useSession } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC } from "react";

const enum fields {
    snapPayVisibility = "snapPayVisibility",
}

const enum snapPayAccessModes {
    showForSnapPayUsers = "showForSnapPayUsers",
    hideForSnapPayUsers = "hideForSnapPayUsers",
}

export interface RestrictedContentBySnapPayRoleProps extends WidgetProps {
    id: string;
    fields: {
        [fields.snapPayVisibility]: snapPayAccessModes;
    };
}

const getUserRoles = (value?: string | null): string[] => {
    if (!value) {
        return [];
    }

    return value
        .split(",")
        .map(x => x.trim())
        .filter(Boolean);
};

const RestrictedContentBySnapPayRole: FC<RestrictedContentBySnapPayRoleProps> = ({ id, fields }) => {
    const { isEditing } = useShellContext();
    const session = useSession();

    const { snapPayVisibility: mode } = fields;

    const currentRoles = getUserRoles(session?.userRoles);
    const isSnapPayUser = currentRoles.includes(userRoles.snapPay);

    const hasAccess =
        isEditing ||
        (mode === snapPayAccessModes.showForSnapPayUsers && isSnapPayUser) ||
        (mode === snapPayAccessModes.hideForSnapPayUsers && !isSnapPayUser);

    return hasAccess ? <Zone zoneName="RestrictedContent" contentId={id} /> : null;
};

const widgetModule: WidgetModule<Toolkit.FieldDefinition> = {
    component: RestrictedContentBySnapPayRole,
    definition: {
        group: constants.widgetGroup.layout,
        displayName: "Restricted Content Wrapper (SnapPay)",
        fieldDefinitions: [
            {
                name: fields.snapPayVisibility,
                displayName: "Show content for",
                editorTemplate: "DropDownField",
                fieldType: "General",
                isRequired: true,
                defaultValue: "",
                tooltip: "Choose which audience should see the content inside this wrapper.",
                options: [
                    {
                        displayName: "SnapPay users",
                        value: snapPayAccessModes.showForSnapPayUsers,
                    },
                    {
                        displayName: "Non-SnapPay users",
                        value: snapPayAccessModes.hideForSnapPayUsers,
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
